import React from 'react';
import LinearProgress from '@material-ui/core/LinearProgress';
import { withStyles, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import cn from 'classnames';

const styles = theme => ({
  loadingWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    height: '100vh',
  },
  loadingWrapperEmbedded: {
    height: 'auto',
    minHeight: 420,
    flex: 1,
    alignSelf: 'stretch',
  },
  progressWrapper: {
    margin: '0 auto',
    textAlign: 'center',
    width: '100%',
    maxWidth: 480,
    padding: '0 24px',
  },
  progressTitle: {
    marginBottom: 24,
  },
});

const FullScreenLoading = ({ classes, message = 'Preparing App...', embedded = false, titleVariant = 'h5' }) => {
  return (
    <div className={cn(classes.loadingWrapper, embedded && classes.loadingWrapperEmbedded)}>
      <div className={classes.progressWrapper}>
        <Typography className={classes.progressTitle} variant={titleVariant} color="primary">
          {message}
        </Typography>
        <LinearProgress />
      </div>
    </div>
  );
};

FullScreenLoading.propTypes = {
  message: PropTypes.string,
  embedded: PropTypes.bool,
  titleVariant: PropTypes.string,
};

export default withStyles(styles)(FullScreenLoading);
